import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe, PipeTransform} from '@angular/core';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
declare var $:any;
import * as moment from 'moment/moment';
import {CsvService} from 'angular2-json2csv';
import { DialogService,DialogComponent} from 'ng2-bootstrap-modal';
import {AlertHistoryComponent} from '../alert-history/alert-history.component';
import { IOption } from 'ng-select';
import { Popup } from 'ng2-opd-popup';


@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: Array<any>, filter: {[key: string]: any }): Array<any> {
        return items.filter(item => {
                let notMatchingField = Object.keys(filter)
                                             .find(key => item[key] !== filter[key]);

                return !notMatchingField; // true if matches all fields
            });
    }
}


@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
  
})

export class HistoryComponent implements OnInit {
	constructor(private dialogservice:DialogService,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private http: Http,private router:Router,private route : ActivatedRoute,private csvService: CsvService){}
	listContractLevel=[];
	finalArr=[];
	ListAllHistroyDetails=[];
	AllMakedetails=[];
	AllModalDetails=[];
	CUSTOMERNAMEplaceholder:string="CUSTOMER NAME";
	SERIALNUMBERplaceholder:string="SERIAL NUMBER";
	MAKEplaceholder:string="MAKE";
	MODELplaceholder:string="MODEL";
	customerNameDropDown:Array<IOption>=[];
	SerialNumberDropDown:Array<IOption>=[];
	MakeDropDown:Array<IOption>=[];
	ModelDropDown:Array<IOption>=[];
	ListOfPreventiveMaintenanceDetails:any[] = [];
	loading:boolean=true;
	ListOfSerialNumber:any[]=[];
	ListOfCustomerMaster:any[]=[];
	customerDetails:any[]=[];
	reqMakeId:any;
	make:any;
	reqmodelId:any;
	model:any;
	msgtext:any;
	clientName:any;
	listhistorydetails:any[] = [];
	ListAllMake:any[]=[];
	ListbranchDetails:any[]=[];
	ListAllModel:any[]=[];
	listAS:any[]=[];
	ListFinaldata:any[]=[];
	ListSerialNumber:any[]=[];
	ListMake:any[]=[];
	ListModel:any[]=[];
	ListCustomerNumber:any[]=[];
	smake:any;
	smodel:any;
	customerName:any;
	serialnumber:any;
	sendMake:any;
	sendModel:any;
	sendCustomer:any;
	CSconfig2: any = {'placeholder': 'CUSTOMER NAME', 'sourceField': ['customer_Name']};
	SNconfig2: any = {'placeholder': 'SERIAL NUMBER', 'sourceField': ['serial_Number']};
	config2MK: any = {'placeholder': 'MAKE', 'sourceField': ['make']};
	config2MD: any = {'placeholder': 'MODEL', 'sourceField': ['model']};
	@ViewChild('Histroy') Histroy: Popup;
	fromDate:any;
	toDate:any;
  	listSearchData:any[] = [];
  	date:any;
  	CustomerName:any;
  	Location:any;
  	Make:any;
  	Model:any;
  	MechineSerialNumber:any;
  	ServiceType:any;
  	Labour:any;
  	Spares:any;
	Travel:any;
	Response:any[] = [];
	ListOfCheckListMaster:any[] = [];
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	histroy:any[]=[];
  	serialNumber:any;
  	mcLocation:any;
  	phoneNumber:any;
  	email:any;
  	hmrHours:any;
  	technicianName:any;
  	lastServiceType:any;
  	lastServiceHours:any;
  	yearOfManufacture:any;
  	branch:any;
  	serviceContractOfferedYear:any;
  	contractReference:any;
  	noofServiceContractYears:any;
  	startDate:any;
  	endDate:any;
  	noOfservice:any;
  	serviceRemainderDays:any;
  	currentService:any;	
	ListserviceDetails:any;
	histroyPP:any[] = [];
	ListAllServcieType = [];
  	ServiceContractExtend = [];
  	histroyPr = [];
  	ListTechnicianName = [];
  	techinicianDetails = [];
  	orgId:number;
  	userId:number; 
  	pmadelete:any;
	  ListOfOnlySerialNumber;
  	@ViewChild('Askdelete') Askdelete: Popup;
  	

	ngOnInit() {
		this.loading=true;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	      window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
		this.getAllMakeDetails();
		this.getBranchDetails();
		this.getAllserialNumberDetails();
		this.getAllServiceTypeDetails();
		this.getTechnicianName();
		//this.getmodeldetails();
		this.getmakedetailsforhistory();
		this.getmodeldetailsforhistory();
	}

	getBranchDetails(){
		let obj={
		 'orgId':this.orgId
		}
		return this.http.post('/api/getbranchdetails',obj).subscribe(res=>{
			 this.ListbranchDetails=res.json();
		})
	 }

	 deletePMA(pmaId) {
	 	console.log(this.listhistorydetails);
	 	this.pmadelete=pmaId;
		$("#Askdelete").modal('show');
	 	
	 }

	Yes() {
		console.log(this.listhistorydetails);
		$("#Askdelete").modal('hide');
		this.loading=true;
	 	let obj = {
	 		'pmaId':this.pmadelete
	 	}
	 	return this.http.post('/api/deletePMAContract',obj).subscribe(res=>{
	 		let PMAResponse = res.json();
	 		
			if(PMAResponse.response == 'PMA Contract Delete Successfully') {
				this.loading=false;
				alert('PMA Contract Delete Successfully');
				this.reset();
				this.getAllPreventiveMaintenanceDetails();
				//this.getAllMakeDetails();
				this.getBranchDetails();
				this.getAllserialNumberDetails();
				this.getAllServiceTypeDetails();
				this.getTechnicianName();
				this.getmakedetailsforhistory();
				this.getmodeldetailsforhistory();
			} else if(PMAResponse.response == 'PMA contract Already deleted'){
				this.loading=false;
				alert('PMA contract Already deleted');
				this.reset();
				this.getAllPreventiveMaintenanceDetails();
				//this.getAllMakeDetails();
				this.getBranchDetails();
				this.getAllserialNumberDetails();
				this.getAllServiceTypeDetails();
				this.getTechnicianName();
				this.getmakedetailsforhistory();
				this.getmodeldetailsforhistory();
			} 
		},(err)=>{
			this.loading=false;
		})
	}

	// No() {
	//  	this.Askdelete.hide();
	// }

	//  downloadHistory() {
	//  	this.csvService.download(this.ListOfOnlySerialNumber,'hISTORY');
	//  }

	showAlert(){
		 
		this.loading=false;
		console.log("ListAllHistroyDetails",this.ListAllHistroyDetails)
		this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',values:this.ListAllHistroyDetails,contractlevelArr:this.listContractLevel,'finalArr':this.finalArr,'customIndex':0})
		
	}
	getTechnicianName() {
    	let techObj = {
        'orgId':this.orgId
      	}
		return this.http.post('/api/getTechniciansName', techObj).subscribe(
	    res => {
        	res.json();
	    	this.ListTechnicianName = res.json();
	        let technicianArr = []
	        for(var i=0;i<this.ListTechnicianName.length;i++) {
	          let obj = {
	            'label':this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME,
	            'value':this.ListTechnicianName[i].ID
	          }
	          technicianArr.push(obj);
	        }
	        this.techinicianDetails = technicianArr;
		})
	}


	getmakedetailsforhistory() {
  
		let makeObj = {
		  'orgId':this.orgId
		}
		return this.http.post('/api/getMakedetails', makeObj).subscribe(
		 res => {
		    
		   this.AllMakedetails=[];
		   let response = res.json();
		   if(response.length>0) {
			 this.AllMakedetails = response;
			 
		   }
		 },(err)=>{
		   this.loading=false;
		  // this.spinner.hide();
		 })
	  }


	  getmodeldetailsforhistory() {
		// this.loading=true;
			 let modelObj = {
				 'orgId':this.orgId
			 }
			 return this.http.post('/api/getModelDetails', modelObj).subscribe(
				res => {
					 
					this.AllModalDetails = [];
					let response = res.json();
					if(response.length>0) {
						this.AllModalDetails =response;
						//this.model = response[0].model.toUpperCase();;
					}
				},(err)=>{
					this.loading=false;
				//	this.spinner.hide();
				})
		 }


	reset() {
		this.loading=true;
		this.customerName = "";
		this.serialnumber = "";
		this.smake = "";
		this.smodel = "";
		this.clientName="";
		this.make="";
		this.model="";
		this.CUSTOMERNAMEplaceholder="CUSTOMER NAME";
		this.SERIALNUMBERplaceholder="SERIAL NUMBER";
		this.MAKEplaceholder="MAKE";
		this.MODELplaceholder="MODEL";
		this.listhistorydetails=[];	
		this.getAllMakeDetails();
	}

	getCount(){

		if(this.p < Math.ceil(this.listhistorydetails.length/10)){
		  this.startingCount = (this.p-1)*10;
		  if(this.startingCount == 0){
			this.startingCount = 1;
		  }
		  this.endingCount = this.p*10;
		} else if(this.p == Math.ceil(this.listhistorydetails.length/10)){
		  let count = this.listhistorydetails.length%10;
		  this.startingCount = (this.p-1)*10;
		  this.endingCount = this.startingCount + count;
		  if(this.startingCount == 0){
			this.startingCount = 1;
			this.endingCount = count;
		  }
		}
	   }
	   
	onSelectCS(val: string) {
	}

	onInputChangedEventCS(val: string) {
	}

	onInputChangedEventSN(val: string) {
	}

	onSelectSN(val: string) {
	}

	onInputChangedEventMK(val: string) {
	}

	onSelectMK(val: string) {
	}

	onInputChangedEventMD(val: string) {
	}

	onSelectMD(val: string) {
	}

	getAllserialNumberDetails() {

        let PMSObj = {
        	'orgId':this.orgId
        }
        return this.http.post('/api/getAllPreventiveMaintenanceDetails', PMSObj).subscribe(
            res => {

			this.ListOfSerialNumber = res.json();
			let pusharr=[];
			for(let i=0;i<this.ListOfSerialNumber.length;i++){
			   pusharr.push({'value':this.ListOfSerialNumber[i]._id.toString(),'label':this.ListOfSerialNumber[i].serial_Number.toUpperCase()})

			}
		
			  this.SerialNumberDropDown=pusharr;
			//   this.getserialNumber()
        })
    }

	// getserialNumber()  {
	// 	let PMSObj = {
    //     	'orgId':this.orgId
    //     }
    //     return this.http.post('/api/getSerialNumberOnly', PMSObj).subscribe(
    //         res => {
	// 			let pusharr=[];
	// 		let response = res.json();
	// 		for(let i=0;i<response.length;i++){
	// 			console.log(response[i].serial_Number.toUpperCase());
	// 			pusharr.push(response[i].serial_Number.toUpperCase())
 
	// 		 }
	// 		this.ListOfOnlySerialNumber=pusharr
	
			  
    //     })
	// }
	getAllMakeDetails() {
		let makeObj ={
			'orgId':this.orgId
		}
	    return this.http.post('/api/getMakedetails', makeObj).subscribe(
        res => {
			   this.ListAllMake = res.json();
			   let pusharr=[];
			   for(let i=0;i<this.ListAllMake.length;i++){
				  pusharr.push({'value':this.ListAllMake[i]._id.toString(),'label':this.ListAllMake[i].make.toUpperCase()})
   
			   }
				 this.MakeDropDown=pusharr;
       		this.getAllModelDetails()
        },(err)=>{
        	this.getAllModelDetails()
       		this.msgtext = "Unable to load the make Value";
            this.getWarningFunction(this.msgtext);
        })
	}

	getAllModelDetails() {
		let modelObj ={
			'orgId':this.orgId
		}
	    return this.http.post('/api/getAllModeldetails', modelObj).subscribe(
        res => {
			   this.ListAllModel = res.json();
			   let pusharr=[];
			   for(let i=0;i<this.ListAllModel.length;i++){
				  pusharr.push({'value':this.ListAllModel[i]._id.toString(),'label':this.ListAllModel[i].model.toUpperCase()})
			   }
				 this.ModelDropDown=pusharr;
       		this.getAllDetailsFromCustomerMaster();
        },(err)=>{
        	this.getAllDetailsFromCustomerMaster();
       		this.msgtext = "Unable to load the model Value";
            this.getWarningFunction(this.msgtext);
        })
	}

	getAllServiceTypeDetails() {
		let serviceObj ={
			'orgId':this.orgId
		}
	    return this.http.post('/api/getServiceTypedetails', serviceObj).subscribe(
        res => {
       		this.ListAllServcieType = res.json();
        },(err)=>{
       		alert('unable to load make values')
        })
	}
	

    getAllDetailsFromCustomerMaster () {
    	let customerObj ={
			'orgId':this.orgId
		}
  		return this.http.post('/api/getCustomerMasterDetails', customerObj).subscribe(
     	res => {
     		this.ListOfCustomerMaster = res.json();
     		for(var i=0;i<this.ListOfCustomerMaster.length;i++) {
     			let obj = {
     				'Id':this.ListOfCustomerMaster[i]._id,
     				'Name':this.ListOfCustomerMaster[i].customer_Name
     			}
				 this.customerDetails.push(obj); 
			 }
			 let pusharr=[];
			 for(let i=0;i<this.ListOfCustomerMaster.length;i++){
				pusharr.push({'value':this.ListOfCustomerMaster[i]._id.toString(),'label':this.ListOfCustomerMaster[i].customer_Name.toUpperCase()})

			 }
       		this.customerNameDropDown=pusharr;

     		this.getAllPreventiveMaintenanceDetails();
      	},(err)=> {
      		this.getAllPreventiveMaintenanceDetails();
      		this.msgtext = "Unable to load the Value";
            this.getWarningFunction(this.msgtext);
      	})
  	}

  	getAllPreventiveMaintenanceDetails() {
        // this.spinner.show();
        let PMSObj ={
			'orgId':this.orgId
		}
        return this.http.post('/api/getAllPreventiveMaintenanceDetails', PMSObj).subscribe(
            res => {
            // this.spinner.hide();
			let CustomerArr = [];
			this.clientName="";
			this.make="";
			this.model="";
			this.listhistorydetails=[];
			this.ListOfPreventiveMaintenanceDetails = res.json();
			// this.loading=false;
            for (let i=0;i<this.ListOfPreventiveMaintenanceDetails.length;i++ ) {
            	for(let k =0;k<this.customerDetails.length;k++) {
		      		if( this.ListOfPreventiveMaintenanceDetails[i].client_Name == this.customerDetails[k].Id){
		      			this.clientName = this.customerDetails[k].Name
		      		}
		      	}
		      	for(let mk=0;mk<this.ListAllMake.length;mk++) {
		      		if( this.ListOfPreventiveMaintenanceDetails[i].make == this.ListAllMake[mk]._id){
		      			this.make = this.ListAllMake[mk].make
		      		}
		      	}

		      	for(let md=0;md<this.ListAllModel.length;md++) {
		      		if( this.ListOfPreventiveMaintenanceDetails[i].model == this.ListAllModel[md]._id){
		      			this.model = this.ListAllModel[md].model
		      		}
		      	}
		      	let reqobj = {
		        	'serialNumber':this.ListOfPreventiveMaintenanceDetails[i].serial_Number,
		        	'make':this.make,
		        	'model':this.model,
		        	'customerName':this.clientName,
					'id':this.ListOfPreventiveMaintenanceDetails[i]._id,
					'contractLevel':this.ListOfPreventiveMaintenanceDetails[i].contractLevel
		        }
				this.listhistorydetails.push(reqobj);
				
			}
			this.loading=false;
        },(err)=> {
      		this.msgtext = "Unable to load the Value";
            this.getWarningFunction(this.msgtext);
      	})
    }



    getInfodata() {
		// this.spinner.show();
		this.sendMake="";
		this.sendModel ="";
		this.sendCustomer="";
		 
	
		for(let i=0;i<this.ListAllMake.length;i++){
		    if(this.smake==this.ListAllMake[i]._id){
				this.smake=this.ListAllMake[i].make;
				this.MAKEplaceholder=this.smake.toUpperCase();
			}
	}
	  for(let i=0;i<this.ListAllModel.length;i++){
		if(this.smodel==this.ListAllModel[i]._id){
			this.smodel=this.ListAllModel[i].model;
			this.MODELplaceholder=this.smodel.toUpperCase();
		}
 	}

 		 for(let i=0;i<this.customerDetails.length;i++){
		if(this.customerName==this.customerDetails[i].Id){
		this.customerName=this.customerDetails [i].Name;
		this.CUSTOMERNAMEplaceholder=this.customerName.toUpperCase();
		}
	}
		for(let i=0;i<this.ListOfSerialNumber .length;i++){
		if(this.serialnumber==this.ListOfSerialNumber[i]._id){
		this.serialnumber=this.ListOfSerialNumber[i].serial_Number;
		this.SERIALNUMBERplaceholder=this.serialnumber.toUpperCase();
		}
	}
    	if(this.smake == undefined || this.smake == "" || this.smake == null) {

    	} else {
    		for(let mk=0;mk<this.ListAllMake.length;mk++) {
	      		if( this.smake == this.ListAllMake[mk].make){
	      			this.sendMake = this.ListAllMake[mk]._id
	      		}
	      	}
    	}
    	
    	if(this.smodel == undefined || this.smodel == "" || this.smodel == null) {

    	} else {
    		for(let md=0;md<this.ListAllModel.length;md++) {
	      		if( this.smodel == this.ListAllModel[md].model){
	      			this.sendModel = this.ListAllModel[md]._id
	      		}
	      	}
    	}

    	if(this.customerName == undefined || this.customerName == "" || this.customerName == null) {

    	} else {
    		for(let md=0;md<this.customerDetails.length;md++) {
	      		if( this.customerName == this.customerDetails[md].Name){
	      			this.sendCustomer = this.customerDetails[md].Id
	      		}
	      	}
    	}

    	let reqObj = {
    		'serialnumber':this.serialnumber,
    		'customerName':this.sendCustomer,
    		'make':this.sendMake,
    		'model':this.sendModel,
    		'orgId':this.orgId
    	}
    	 
    	return this.http.post('/api/getAllPreventiveMaintenanceDetailsForHistory', reqObj).subscribe(
        res => {
        	 
        	// this.spinner.hide();
            let CustomerArr = [];
						this.listhistorydetails = [];
						this.clientName="";
						this.make="";
						this.model="";
            this.ListOfPreventiveMaintenanceDetails = res.json();
            for (let i=0;i<this.ListOfPreventiveMaintenanceDetails.length;i++ ) {
            	for(let k =0;k<this.customerDetails.length;k++) {
		      		if( this.ListOfPreventiveMaintenanceDetails[i].client_Name == this.customerDetails[k].Id){
		      			this.clientName = this.customerDetails[k].Name
		      		}
		      	}
		      	for(let mk=0;mk<this.ListAllMake.length;mk++) {
		      		if( this.ListOfPreventiveMaintenanceDetails[i].make == this.ListAllMake[mk]._id){
		      			this.make = this.ListAllMake[mk].make
		      		}
		      	}

		      	for(let md=0;md<this.ListAllModel.length;md++) {
		      		if( this.ListOfPreventiveMaintenanceDetails[i].model == this.ListAllModel[md]._id){
		      			this.model = this.ListAllModel[md].model
		      		}
		      	}
		      	let reqobj = {
		        	'serialNumber':this.ListOfPreventiveMaintenanceDetails[i].serial_Number,
		        	'make':this.make,
		        	'model':this.model,
					'customerName':this.clientName,
					'id':this.ListOfPreventiveMaintenanceDetails[i]._id,
					'contractLevel':this.ListOfPreventiveMaintenanceDetails[i].contractLevel

		        }
		        this.listhistorydetails.push(reqobj);
		        this.sendCustomer = "";
						this.sendMake = "";
						this.sendModel = "";
						this.loading=false;
		    }
        },(err)=> {
      		this.msgtext = "Unable to load the Value";
            this.getWarningFunction(this.msgtext);
      	})
	}


	getmodeldetails() {
      let modelObj = {
        'modelId':this.reqmodelId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getModeldetailsBasedOnId', modelObj).subscribe(
       res => {
         let response = res.json();
         if(response.length>0) {
           this.model = response[0].model.toUpperCase();;
         }
       })
    }

    close() {
      this.Histroy.hide();
    }

    getmakedetails() {
      let makeObj = {
        'makeId':this.reqMakeId,
         'orgId':this.orgId
      }
      return this.http.post('/api/getMakedetailsBasedOnId', makeObj).subscribe(
       res => {
         let response = res.json();
         if(response.length>0) {
           this.make = response[0].make.toUpperCase();;
         }
       })
    }


	viewallHistory(pmId, serialNumber) {
		let ReqObjValue = {
			'pmId':pmId
		}
		return this.http.post('/api/getHistoryDetailsBasedOnContractLevel', ReqObjValue).subscribe(
    	res=>{ 
			this.histroy = res.json();
			this.clientName="";
			this.technicianName="";
			this.lastServiceType = "";
       		this.ListAllHistroyDetails=[];
			for(let h=0;h<this.histroy.length;h++) {
				
				for(var k =0;k<this.customerDetails.length;k++) {
					if( this.histroy[0].client_Name == this.customerDetails[k].Id){
					  this.clientName = this.customerDetails[k].Name
					}
				  }
				  //this.extensionUpdateId = this.histroy[h]._id
				  for(let m=0;m<this.AllMakedetails.length;m++ ) {
					if(this.AllMakedetails[m]._id == parseInt(this.histroy[h].make)) {
									  
					  this.make = this.AllMakedetails[m].make;
					}
					}
					 
					for(let n=0;n<this.ListbranchDetails.length;n++){
						if(this.ListbranchDetails[n]._id==this.histroy[h].branch){
						 this.histroy[h].branch=this.ListbranchDetails[n].branchAlias
						}
					}
	  
				  for(let md=0;md<this.AllModalDetails.length;md++ ) {
					if(this.AllModalDetails[md]._id == parseInt(this.histroy[h].model)) {
					  this.model = this.AllModalDetails[md].model;
					}
				  }
				  for(let t=0;t<this.techinicianDetails.length;t++) {
					if(this.techinicianDetails[t].value == parseInt(this.histroy[h].technician_Name)) {
					  this.technicianName = this.techinicianDetails[t].label;
					}
					}
					 
				  for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
					if(this.ListAllServcieType[ls]._id == parseInt(this.histroy[h].last_Service_Type)) {
					  this.lastServiceType = this.ListAllServcieType[ls].servicetype;
					}
					}
					// for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
    	// 		  for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
     // 				 if(this.histroy[h].serviceScheduleDay-1 > i ){
     //   					if(this.ListAllServcieType[ls]._id ==this.histroy[h].Servicedetails[i].service_Type ) {
     //    					this.lastServiceType = this.ListAllServcieType[ls].servicetype;
     //   						}
     //  				}

     // 			 }		
    
    	// 	 }
			

					if((this.lastServiceType==undefined||this.lastServiceType=="")&&this.histroy[h].last_Service_Type=="New Vehicle"){
						this.lastServiceType="New Vehicle"
					 }
				
				  for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
					for(let k=0;k<this.ListAllServcieType.length;k++) {
					  if(parseInt(this.histroy[h].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
						this.histroy[h].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
					  }
					}
				
					
				  }
				  let histroyObject = {
					'clientName':this.clientName,
					'pmId':this.histroy[h]._id,
					'serialNumber':this.histroy[h].serial_Number,
					'mcLocation':this.histroy[h].mcLocation,
					'phoneNumber':this.histroy[h].phone_Number,
					'email':this.histroy[h].email,
					'make':this.make,
					'modal':this.model,
					'hmr':this.histroy[h].hmr,
					'contractLevel':this.histroy[h].contractLevel,
					'technicianName':this.technicianName,
					'lastserviceType':this.lastServiceType,
					'lastServiceHours':this.histroy[h].last_Service_Hours,
					'yearOfManufacturer':this.histroy[h].year_Of_manufacturer,
					'branch':this.histroy[h].branch,
					'contractRefernce':this.histroy[h].contract_Reference,
					'noofServiceContractYears':this.histroy[h].noofServiceContractYear,
					'startDate':moment(this.histroy[h].start_Date).format("D MMM YYYY"),
					'endDate':moment(this.histroy[h].end_Date).format("D MMM YYYY"),
					'newstartdate':this.histroy[h].start_Date,
					'newenddate':this.histroy[h].end_Date,
					'noOfservice':this.histroy[h].no_Of_Service,
					'serviceRemainderDays':this.histroy[h].remainderday,
					'currentService':this.histroy[h].serviceScheduleDay,
					'ListserviceDetails': this.histroy[h].Servicedetails,
					'lastServiceStatusOfContract':'',
					'histroyPr':[],
					'histroyPp':[],
					'ServiceContractExtend':[]
	  
							  }
						  
							  this.ListAllHistroyDetails.push(histroyObject);


			}

    		
			
    		let reqObj = {
	          'serialNumber':serialNumber,
	        }
	        return this.http.post('/api/getListAllPostPonedHistroy', reqObj).subscribe(
	        res=>{ 
	           
	          let ppHis = res.json();
	           this.histroyPP = [];
	           this.histroyPr = [];
	           if(ppHis.length>0) {
	            for(var p=0;p<ppHis.length;p++) {
	              if(ppHis[p].type == 'servicePrepone') {
	                let pphis = {
	                  'serialNumber':ppHis[p].serialNumber,
	                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
	                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
	                  'schedularNumber':ppHis[p].schedularNumber
	                }
					this.histroyPr.push(pphis);
					for(let pr=0;pr<this.ListAllHistroyDetails.length;pr++) {
						if(this.ListAllHistroyDetails[pr].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pr].contractLevel == ppHis[p].contractLevel) {
							this.ListAllHistroyDetails[pr].histroyPr = this.histroyPr;
						}
					} //for loop end here
	              } else if(ppHis[p].type == 'servicePostpone') {
	                let pphis = {
	                  'serialNumber':ppHis[p].serialNumber,
	                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
	                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
	                  'schedularNumber':ppHis[p].schedularNumber
	                }
					this.histroyPP.push(pphis);
					for(let pp=0;pp<this.ListAllHistroyDetails.length;pp++) {
						if(this.ListAllHistroyDetails[pp].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pp].contractLevel == ppHis[p].contractLevel) {
							this.ListAllHistroyDetails[pp].histroyPp = this.histroyPP;
						}
					} //for loop end here
	              }
	              
	              
	              
	            }
	          }
	          
	          let reqExtendobj = {
	            'serialNumber':serialNumber,
	          }
	          return this.http.post('/api/getListAllServiceContractExtendHistroy', reqObj).subscribe(
	          res=>{ 
	            let SCExtend = res.json();
	            this.ServiceContractExtend = [];
	            if(SCExtend.length>0) {
	              for(var n=0;n<SCExtend.length;n++) {
	                let SCEobj = {
	                  'serialNumber':SCExtend[n].serialNumber,
	                  'startdate':moment(SCExtend[n].startdate).format("D MMM YYYY"),
	                  'enddate':moment(SCExtend[n].enddate).format("D MMM YYYY"),
	                  'contractExtensionDate':moment(SCExtend[n].contractExtensionDate).format("D MMM YYYY")
	                }
	                this.ServiceContractExtend.push(SCEobj);
	              }
				}
				
				let statusObj = {
					'pmId':this.ListAllHistroyDetails[0].pmId,
					'serialNumber':this.ListAllHistroyDetails[0].serialNumber
				}
				return this.http.post('/api/serviceStatusChecking_serviceFormAPI', statusObj).subscribe(
				res => {
					 
					let response = res.json();
					if(response.length > 0) {
						if(response[response.length-1].service_Scheduler_Number == this.ListAllHistroyDetails[0].noOfservice && response[response.length-1].status == 1) {
							this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'completed';
						} else {
							this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'notcompleted';
						}
					}
					console.log('this.ListAllHistroyDetails '+ this.ListAllHistroyDetails)
					this.loading=true;
					document.body.scrollTop = 0;
					document.documentElement.scrollTop = 0;
					this.showAlert();
				})
	           
	            
				
	          })
	          
	        })
	        
	    })
	     
	}

  	

    getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "History page",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	      };
	    this.toastyService.warning(toastOptions);
	}//getWarningFunction end here


	getSuccessFunction(successMsg){
	    var toastOptions:ToastOptions = {
	      title: "History page",
	      msg: successMsg,
	      showClose: true,
	      timeout: 3000,
	      theme: 'bootstrap',
	      onAdd: (toast:ToastData) => {
	      },
	      onRemove: function(toast:ToastData) {
	      }
	    };
	    this.toastyService.success(toastOptions);
	}//getSuccessFunction end here
}


// WEBPACK FOOTER //
// ./client/app/history/history.component.ts